import React from "react";
import Layout from "../components/Layout/Layout";
import ContactPageSection from "../components/contact/ContactPageSection";

const Contact = () => {
  return (
    <Layout title="Contact us - Medicure">
      <ContactPageSection />
    </Layout>
  );
};

export default Contact;
